import * as service from './service'
export default {
  namespace: 'levelSysMyLevelRecord',
  state: {},
  effects: {
    * levelRecord ({ payload }, { call }) {
      const res = yield call(service.levelRecord, payload)
      return res.data && res.data.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
